module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.7429a63.ttf";